import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import messengerMyRoomsListSaga from './sagas/messengerMyRoomsListSaga';
import personalUniversalSearchListSaga from './sagas/personalUniversalSearchListSaga';

export default [
  // Lists
  ...createCombineMapItem('messengerMyRoomsList', createListReduceObject, [
    messengerMyRoomsListSaga
  ]),
  ...createCombineMapItem(
    'personalUniversalSearchList',
    createListReduceObject,
    [personalUniversalSearchListSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/reducers/static/lists/reducersMap.js